import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

import { getToken } from '~services/auth';

import config from '~constants/config';

interface Api {
  http: AxiosInstance;
}

const httpClient = axios.create({
  baseURL: config.API_URL,
  withCredentials: true,
}) as AxiosInstance;

const api: Api = {
  http: httpClient,
};

export async function afterQueryMessages(
  successMessage: string,
  errorMessage: string,
  { queryFulfilled }: { queryFulfilled: Promise<unknown> }
) {
  try {
    await queryFulfilled;
    // TODO: Show success message
  } catch {
    // TODO: Show error message
  }
}

// Interceptors ==============================================================
api.http.interceptors.request.use(
  async config => {
    const accessToken = await getToken();
    config.headers.set('Authorization', `Bearer ${accessToken}`);

    if (config.url && !config.url.includes('api-version')) {
      config.params = {
        'api-version': '2022-09-05-preview',
        ...config.params,
      };
    }

    return config;
  },
  error => {
    console.log('>>', error);
    return Promise.reject(error);
  }
);

api.http.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError & { message?: string | undefined }) => {
    if (!error.response) {
      if (axios.isCancel(error) || error.message === 'Not authenticated') {
        return Promise.reject(error);
      }

      console.error('> Network error', {
        method: error.config?.method?.toUpperCase() ?? 'UNKNOWN',
        url: error.config?.url ?? '(request not sent)',
        code: error.code,
        message: error.message,
      });
      return Promise.reject(error);
    }

    // console.log('> API response error', response);
    // const message = (response?.data as any)?.message
    //   ? JSON.stringify((response?.data as any)?.message)
    //   : undefined;
    // Axios wraps errors returned by the api inside `response.data`

    return Promise.reject(error);
  }
);

export default api;
